import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  Icon,
} from "@assetwatch/ui";
import { Link } from "@tanstack/react-router";
import type { WorkOrdersLocationSearch } from "../../../lib/workOrdersSearch";
import { BackCrumb } from "../../navigation/ContextualBack";

export function WorkOrdersBreadcrumb({
  canNavigate,
  search,
}: {
  canNavigate: boolean;
  search: WorkOrdersLocationSearch;
}) {
  if (canNavigate) {
    return (
      <BackCrumb
        label="Work Orders"
        link={<Link search={search} to="/work-orders" />}
      />
    );
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbPage>
            <span className="inline-flex items-center gap-(--spacing-4)">
              <Icon name="chevron-left" size="xs" tone="inherit" />
              Work Orders
            </span>
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
